import React from 'react';

interface Props {
    onSelect: (item: any) => void;
    items: any[];
};

const Select = (props: Props) => {
    return (
	<div className="select">
	    {props.items.map((el, idx) => (
		<div onClick={e => props.onSelect(el)} key={idx} className="item">{el.name}</div>
	    ))}
	</div>
    );
};

export default Select;